import React, { useState, useEffect } from 'react';

const API_URL = 'https://jxbk.jingchaowan.dpdns.org';

const History = ({ selectedOperator, onBack }) => {
    const [history, setHistory] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!selectedOperator) return;

        const fetchHistory = async () => {
            setLoading(true);
            try {
                const response = await fetch(`${API_URL}/performance-history?person=${selectedOperator.operator_name}`);
                if (!response.ok) {
                    throw new Error('获取历史数据失败');
                }
                const data = await response.json();
                // 按月份降序排序
                data.sort((a, b) => new Date(b.performance_month) - new Date(a.performance_month));
                setHistory(data);
            } catch (error) {
                console.error(error);
                alert(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchHistory();
    }, [selectedOperator]);

    return (
        <div className="main-content" style={{ padding: '32px' }}>
            <div className="main-header" style={{ marginBottom: '32px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <button onClick={onBack} style={{ background: 'none', border: '1px solid #d9d9d9', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', color: '#595959', display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
                        返回考核表
                    </button>
                    <h1 style={{ margin: 0, fontSize: '24px' }}>{selectedOperator.operator_name} 的历史档案</h1>
                </div>
            </div>
            {loading ? <div style={{ textAlign: 'center', padding: '40px', color: '#8c8c8c' }}>正在调取历史数据...</div> : history.length > 0 ? (
                history.map(record => (
                    <div key={record.performance_month} className="table-container">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '1px solid #f0f0f0', paddingBottom: '16px' }}>
                            <h2 style={{ margin: 0 }}>{record.performance_month} 考核结果</h2>
                            <div className="total-score" style={{ padding: '8px 16px' }}>
                                <small>最终结果: </small><span>{(record.final_score || 0).toFixed(2)}</span>
                            </div>
                        </div>
                        {record.scores ? (
                            <table>
                                <thead>
                                    <tr>
                                        <th>关键考核指标</th>
                                        <th>得分</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.entries(JSON.parse(record.scores)).map(([indicator, score]) => (
                                        <tr key={indicator}>
                                            <td>{indicator}</td>
                                            <td>{score.toFixed(2)}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : <p>该月份缺少详细得分记录。</p>}
                    </div>
                ))
            ) : <p>没有找到历史绩效记录。</p>}
        </div>
    );
};

export default History;
